export default {
  // --------------------------------------------------------------- Loaded data

  dataRegistry (state) {
    return state.dataRegistry
  },

  // NOTE - This is the new way !!!
  loadedData: state => (resource) => {
    return state.dataRegistry[resource]
  },

  data: state => (resource) => {
    return state.dataRegistry[resource]
  },

  dataItem: state => (resource, itemId) => {
    const collection = state.dataRegistry[resource]
    const item = (collection && collection.items)
      ? collection.items.find(item => item.id === itemId)
      : null
    return item
  },

  // -------------------------------------------------------------- Item editing

  editingRegistry (state) {
    return state.editingRegistry
  },

  itemEditing: state => (resource) => {
    const entry = state.editingRegistry[resource]
    return (entry) ? entry.itemEditing : null
  },

  itemEditingOrigin: state => (resource) => {
    const entry = state.editingRegistry[resource]
    return (entry) ? entry.originRoute : null
  },

  itemEditingFeedback: state => (resource) => {
    const entry = state.editingRegistry[resource]
    return (entry) ? entry.itemEditing_activeMessage : null
  }
}
